module.exports = __webpack_public_path__ + "static/media/astronomy_04.80eb2b2a.jpg";